import type { ImportGlobFunction } from "vite";
import type { RegExpWithGroups } from "../../utils/RegExpWithGroups.js";

const icons: Record<string, string> = (import.meta as ImportMeta & { glob: ImportGlobFunction }).glob<string>(
	"./industries/*.svg",
	{
		eager: true,
		query: "raw",
		import: "default",
	},
);

const regex = /(?<name>[^/]+)\.svg$/u as RegExpWithGroups<{ name: string }>;

export const iconMap = Object.fromEntries(
	Object.entries(icons).map(([path, content]) => {
		const match = regex.exec(path);
		if (!match) {
			throw new Error(`Invalid icon path: ${path}`);
		}
		return [match.groups.name, content];
	}),
);
